import { Input, OriCheckbox } from '@/src/components/Antd';
import React from 'react';
import {
  Item as ItemWrapper,
  SectionContainer as Section,
} from 'src/components/Layouts';
import { Uploader } from 'src/components/Upload';
import css from './css.module.less';

import { useSingleImageEffect } from '@/src/components/Upload';
import { useDispatch } from 'react-redux';
import { onImageCarouselSettingChange } from 'src/constrains/ResponsiveLayerEditor/slice';
//import { get } from 'lodash';
//import { ImageDisplaySetting } from '@/src/components/Upload';
import LinkLibrary from '@/src/constrains/LinkLibrary';
import { get } from 'lodash';
import { errKey } from 'src/constrains/ResponsiveLayerEditor/ImagePosterEdit/tool';
import { mediaTypeCheck } from 'src/tools/helper';
import { MediaType } from 'src/types/common/common';
import FocusPoint from 'src/components/ImageFocusPointEdit';

const CarouselSetting = (props) => {
  const d = useDispatch();
  const { data, linkSet, specificError, isConvertible, onChanged, isPoster } =
    props;

  //const [imageSettingVisible, setImageSettingVisible] = React.useState(false);

  const imgError = get(specificError, errKey.image) || [];
  const nameError = get(specificError, errKey.name) || [];
  const linkError = get(specificError, errKey.link) || [];
  //
  const { name, image, imageLink, background, autoplayEnabled, mute } = data;
  const [fileList, setFileList] = React.useState(image ? [image] : []);
  //console.log('fileList', fileList);
  useSingleImageEffect(image, fileList, setFileList);
  const type = mediaTypeCheck(image);

  // const imageSettingFocus = get(image, 'imageSetting.focus');
  // const imageSettingLeft = get(image, 'imageSetting.left');
  // const imageSettingRight = get(image, 'imageSetting.right');
  // const imageSettingTop = get(image, 'imageSetting.top');
  // const imageSettingBottom = get(image, 'imageSetting.bottom');
  //const imageUrl = get(image, 'url');
  //console.log('image', image);

  const handleImageChange = (list: Array<any>) => {
    if (onChanged) {
      onChanged();
    }
    const length = list.length;
    const image = length ? list[length - 1] : null;
    setFileList(list);
    d(onImageCarouselSettingChange({ image }));
    //onImageChange(image);
  };

  const handleInImageSettingChange = (img) => {
    if (onChanged) {
      onChanged();
    }

    //setImageSettingVisible(false);
    // const { leftTop, leftBottom, rightBottom, rightTop } = value || {};
    // const setting = {
    //   left: leftTop,
    //   right: rightBottom,
    //   top: rightTop,
    //   bottom: leftBottom,
    // };
    // const focus = focalValue;
    // const imageSetting = {
    //   ...setting,
    //   focus,
    // };
    // const _image = { ...(image || {}), imageSetting };
    d(onImageCarouselSettingChange(img));
  };

  const renderUnderMedia = () => {
    if (type === MediaType.Image) {
      return (
        <React.Fragment>
          <FocusPoint
            image={get(fileList, 0)}
            onChange={handleInImageSettingChange}
          />
          <LinkLibrary
            // error={(linkErr || []).join(' ')}\
            error={linkError.join(' ')}
            data={imageLink}
            onChange={(imageLink) => {
              if (onChanged) {
                onChanged();
              }
              d(onImageCarouselSettingChange({ imageLink }));
            }}
            linkSet={linkSet}
          />{' '}
        </React.Fragment>
      );
    }
    if (type === MediaType.Video) {
      return (
        <React.Fragment>
          <OriCheckbox
            className={css.checkbox}
            checked={background}
            onChange={(e) => {
              if (onChanged) {
                onChanged();
              }
              const checked = e.target.checked;
              if (checked) {
                d(
                  onImageCarouselSettingChange({
                    background: true,
                    autoplayEnabled: true,
                    mute: true,
                  }),
                );
              } else {
                d(
                  onImageCarouselSettingChange({
                    background: checked,
                  }),
                );
              }
            }}>
            Set video file as a background
          </OriCheckbox>
          <OriCheckbox
            className={css.checkbox}
            disabled={background}
            onChange={(e) => {
              if (onChanged) {
                onChanged();
              }
              const checked = e.target.checked;
              d(
                onImageCarouselSettingChange({
                  autoplayEnabled: checked,
                }),
              );
            }}
            checked={autoplayEnabled}>
            Enable autoplay
          </OriCheckbox>
          <OriCheckbox
            className={css.checkboxLast}
            disabled={background}
            onChange={(e) => {
              if (onChanged) {
                onChanged();
              }
              const checked = e.target.checked;
              d(
                onImageCarouselSettingChange({
                  mute: checked,
                }),
              );
            }}
            checked={mute}>
            Play video on mute
          </OriCheckbox>
        </React.Fragment>
      );
    }

    return null;
  };

  const renderImage = () => {
    return (
      <ItemWrapper
        error={imgError.length > 0}
        errorText={imgError.join(' ')}
        title='Image/Video'
        bottomTitle='Allowed file types: jpeg, gif, png, mov, mp4'>
        <Uploader
          type='Both'
          multiple={false}
          height={180}
          fileList={fileList}
          onChange={handleImageChange}
        />
      </ItemWrapper>
    );
  };

  return (
    <React.Fragment>
      {/* {imageSettingVisible && (
        <ImageDisplaySetting
          src={imageUrl}
          value={
            imageSettingLeft &&
            imageSettingLeft &&
            imageSettingRight &&
            imageSettingTop
              ? {
                  leftTop: imageSettingLeft,
                  leftBottom: imageSettingBottom,
                  rightBottom: imageSettingRight,
                  rightTop: imageSettingTop,
                }
              : null
          }
          visible={imageSettingVisible}
          focalValue={imageSettingFocus}
          onCancel={() => setImageSettingVisible(false)}
          onOk={handleInImageSettingChange}
        />
      )} */}
      <Section size='small'>
        {!isConvertible && (
          <ItemWrapper
            title={isPoster ? 'Poster Name' : 'Carousel Name'}
            size='small'>
            <Input
              help={nameError.join(' ')}
              error={nameError.length > 0}
              maxLength={100}
              size='large'
              value={name}
              onChange={(e) => {
                if (onChanged) {
                  onChanged();
                }
                d(onImageCarouselSettingChange({ name: e }));
              }}
            />
          </ItemWrapper>
        )}

        {renderImage()}

        {renderUnderMedia()}
      </Section>
    </React.Fragment>
  );
};
export default CarouselSetting;
// export default ErrorProcessingHOC(CarouselSetting, {
//   getCollapseOpenStatus: getImageCollapseOpenStatus,
//   onCollapseOpen: onImageCollapseOpen,
//   id: EImageEditCollapse.CarouselSetting,
//   getContent: getImageCarouselSetting,
//   title: 'Carousel Setting',
//   getErrorDisplay: getImageCollapseValidationMsgDisplay,
//   onImageErrorChange,
//   validation: (x, validationProps) => {
//     //const { isPrimary } = validationProps || {};

//     return validateCarouselSetting(x);
//   },
//   headerProps: {
//     dotsFunction: [
//       // {
//       //   onClick: () => {
//       //     const dD = generateFooterStyle();
//       //     store.dispatch(onFooterStyleChange(dD));
//       //   },
//       //   key: 'Reset',
//       //   body: 'Reset',
//       //   isDangerous: true,
//       // },
//     ],
//     hasDots: true,
//     hideDotsWhenNotPrimary: true,
//   },
// });
